<template>
    <div class="container">
        <div class="row">
            <div class="col-lg-4">
                <h2 class="h h--2 h--dark">Nagrody {{contest.name}}</h2>
                <p class="paragraph">Kategoria: <strong>{{ prizeGroup.name }}</strong></p>
                <p class="paragraph">Grupa: <strong>{{ prizeCategory.name }}</strong></p>
                
                <user-points-info-widget/>

                <p class="paragraph"><router-link :to="{name: 'MyPrizes'}" class="">Zamówione nagrody &raquo;</router-link></p>

                <p class="paragraph">
                  UWAGA! Zamówione nagrody
                  stanowią dochód i podlegają
                  opodatkowaniu.
                  Masz pytania? Skontaktuj się
                  z Koordynatorem Geberit Pro.
                </p>
            </div>
            <div class="col-lg-8 prizes__wraper" v-bind:class="{'pending': pagination.pending}">
                <a @click="$router.go(-1)" class="button button--small button--filled-blue prizes__back-to-list-anchor">&laquo; Wróć</a>
                <h3 class="prizes__heading">{{ prizeCategory.name }}</h3>
                <prizes-list :prizes="contest.prizes" :pagination="pagination"/>
            </div>
        </div>
        <page-box-set-widget prizes="true"></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import { store } from '@/app/store'
import moment from 'moment';

export default {
  name: 'PrizeCategoryComponent',
  mixins: [Vue2Filters.mixin],
  props: [
    'newsletterPopup'
  ],
  data () {
    return {
      pagination: {},
      contest: {},
      prizeCategory: {},
      prizeGroup: {}
    }
  },
  beforeRouteEnter(to, from, next) {
    Vue.axios({
        method: 'get',
        url: '/contests/category/' +to.params.contest_id+ '/' + to.params.prize_subgroup_id
    })
    .then((contestsReponse) => {
      next(vm => {
        vm.contest = contestsReponse.data.data.contest;
        vm.contest.checked = true;
        vm.prizeCategory = contestsReponse.data.data.prizeCategory;
        vm.prizeGroup = vm.prizeCategory.group;
        return vm.contest, vm.prizeCategory, vm.prizeGroup;
      })
    })
    .catch(error => next(false));

  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  mounted: function() {
    if( !this.user || this.user.id != 1 ) {
        this.$gtag.pageview({
            page_path: '/nagrody',
        })
    }
  },
  methods: {
    handleOk (evt) {
      // Prevent modal from closing
      evt.preventDefault()
      if (!this.name) {
        alert('Please enter your name')
      } else {
        this.handleSubmit()
      }
    },
    handleSubmit () {
      this.names.push(this.name)
      this.clearName()
      this.$refs.modal.hide()
    },

    /**
     * On change paginate event.
     *
     * @param  {int} page
     * @return void
     */
    onChangePaginate(page) {
      let vm = this

      vm.pagination.pending = true

      Vue.axios({
        method: 'get',
        url: '/prizes',
        params: {
          page: page
        }
      })
      .then(response => {
        vm.prizes = response.data.data.prizes
        vm.pagination = response.data.pagination
      })
      .catch(error => vm.pagination.pending = false)
    },

    show () {
        this.$modal.show('uncertified-user-modal');
      },
      hide () {
        this.$modal.hide('uncertified-user-modal');
      }
  },

}
</script>



// WEBPACK FOOTER //
// src/app/home/prizes/PrizeCategoryComponent.vue